import type { AppStartListening } from '@castlery/shared-redux-store';
import { isAnyOf, Unsubscribe } from '@reduxjs/toolkit';
import { webAddedToCartEvent } from '@castlery/modules-order-domain';
import { webSignedUpEvent } from '@castlery/modules-user-domain';
import { ExtraArgument } from '@castlery/shared-redux-extra';
import { EVENT_FB_CAPI_CUSTOM_ACT_WITH_SIGNUP } from '../events-map';
import { accessInAU } from '@castlery/config';

export function setupTrackingListeners(startListening: AppStartListening): Unsubscribe {
  const subscriptions = [
    startListening({
      matcher: isAnyOf(webAddedToCartEvent, webSignedUpEvent),
      effect: async (action, { dispatch, extra }) => {
        // only track in AU, click up ticket:https://app.clickup.com/t/86eud6n2w
        if (!accessInAU) return;
        const ATC_PREFIX = 'A_';
        const SIGNUP_PREFIX = 'S_';
        const prefix =
          (action as any)?.['meta']?.['arg']?.['endpointName'] === 'addToOrder' ? ATC_PREFIX : SIGNUP_PREFIX;
        // check if the atc and signup are in the same day，if so, track the event
        const { persistenceHandles } = extra as ExtraArgument;
        const atcSignupTimestamp = persistenceHandles.atcSignupTimestamp.getItem();
        const now = Date.now();
        const currentTimestamp = prefix + now.toString();
        // 如果本地记录不存在或者重复操作，则记录timestamp
        if (!atcSignupTimestamp || atcSignupTimestamp?.startsWith(prefix)) {
          // 更新timestamp
          persistenceHandles.atcSignupTimestamp.setItem(currentTimestamp);
          return;
        }
        const timestamp = atcSignupTimestamp.split('_').pop();
        const localTimestamp = Number(timestamp);
        if (now - localTimestamp < 24 * 60 * 60 * 1000) {
          await dispatch(EVENT_FB_CAPI_CUSTOM_ACT_WITH_SIGNUP());
          persistenceHandles.atcSignupTimestamp.removeItem();
        }
      },
    }),
  ];

  return () => {
    subscriptions.forEach((unsubscribe) => unsubscribe());
  };
}
